import React from 'react';
import { Route } from 'react-router-dom';
import { CLIENT_ENDPOINT } from '../constants/client-endpoint';
import { AutoEnrollmentPage } from './auto-enrollment-page';

export const AutoEnrollmentRoute = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINT} component={AutoEnrollmentPage} />
        </React.Fragment>
    );
};
